import { ColDef } from 'ag-grid-community';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { JSON_PRE_GERADO_TIPO } from '@gestor-web/@core/api/ords/model';
import { Store } from '@ngrx/store';
import { CompetenciaPipe } from '@gestor-web/app/shared/pipes/competencia.pipe';
import { NotificationService } from '@gestor-web/app/shared/services';
import { AnalisesService } from '../../analises.service';
import { BaseConsultaComponent } from './base-consulta.component';
import { GridService } from '@gestor-web/app/shared/services/grid.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GeralService } from '@gestor-web/app/shared/services/geral.service';

const COLUMNS: ColDef[] = [
  // Pivot (area=column)
  {
    headerName: 'Status CID',
    field: 'DS_CID',
    pivotIndex: 0,
  },
  {
    headerName: 'Sit. registro',
    field: 'DS_SITUACAO',
    pivotIndex: 1,
  },

  // Row Groups (area=row)
  {
    headerName: '003-Competência',
    field: 'NR_COMPETENCIA',
    rowGroupIndex: 0,
    sort: 'asc',
  },

  // Aggs (area=data)
  {
    headerName: 'Qtde de guia',
    field: 'QTDE_GUIA',
    type: 'int',
    aggFunc: 'sum',
  },

  // Hidden (area=filter)
  {
    headerName: 'CNPJ/CPF exec.',
    field: 'nr_cnpj_cpf_exec',
    hide: true,
  },
];

@Component({
    selector: 'bl-indicadores-consulta-diagnosticos-inespecificos',
    templateUrl: './base-consulta.component.html',
    styleUrls: ['./base-consulta.component.scss'],
    providers: [DecimalPipe],
    standalone: false
})
export class DiagnosticosInespecificosComponent extends BaseConsultaComponent {
  constructor(
    service: AnalisesService,
    notificationService: NotificationService,
    gridService: GridService,
    geralService: GeralService,
    competeciaPipe: CompetenciaPipe,
    decimalPipe: DecimalPipe,
    datePipe: DatePipe,
    store: Store,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      service,
      notificationService,
      gridService,
      geralService,
      competeciaPipe,
      decimalPipe,
      datePipe,
      store,
      router,
      route,
    );
  }

  getColumns(): ColDef[] {
    return COLUMNS;
  }

  getPageTooltip(): string {
    return 'CUBOS_ANALISE.METRICAS.DIAGNOSTICOS_INESPECIFICOS';
  }

  getConsultaTipo(): JSON_PRE_GERADO_TIPO {
    return 'IND_CUBO_CID_INESPECIFICO';
  }

  getExportTitle(): string {
    return '4.5 - Diagnósticos inespecíficos nos eventos de internação (Numerador e Denominador)';
  }

  getExportFilePrefix(): string {
    return 'Cubos-Diagnosticos-Inespecificos';
  }
}
